// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "group-1hSdD";
var _5 = "group__description-19FAT";
var _6 = "icon-1-xTs";
var _7 = "timeline-16F-A";
var _8 = "direction-1kxhg";
var _9 = "time-1rTq3";
var _a = "description-2NIN3";
var _b = "services-P1RPN";
var _c = "empty-3x1qZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "group", _5 as "group__description", _6 as "icon", _7 as "timeline", _8 as "direction", _9 as "time", _a as "description", _b as "services", _c as "empty" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "group": _4, "group__description": _5, "icon": _6, "timeline": _7, "direction": _8, "time": _9, "description": _a, "services": _b, "empty": _c }
